import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";

export const useDownloadLaudo = () => {
  return useMutation({
    mutationFn: ({ uuid }: { uuid: string }) =>
      Agendamento.downloadLaudo({ uuid }),
    onError: () => {
      toast.error("Erro ao baixar o laudo");
    },
  });
};
